var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('header-about'),_c('stats'),_c('achievements-peek'),_c('works-peek'),_c('contact'),_c('blog-peak'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }